import { ChangeEvent, useEffect, useRef } from 'react';

import { theme } from 'shared/styles/theme';

import { Box } from './Box';

import styled from '@emotion/styled';

const TextAreaStyled = styled('textarea')<{ minHeight?: string }>(({ minHeight }) => ({
  fontSize: theme.fontSizes[17],
  width: '100%',
  border: 'none',
  padding: theme.space[3],
  paddingRight: '40px',
  borderRadius: theme.space[4],
  outline: 'none',
  boxSizing: 'border-box',
  resize: 'none',
  overflow: 'hidden',
  //4px толщина бордеров
  minHeight: minHeight ? minHeight : `calc(${theme.space[3]} * 2 + 1.15em + 4px)`,
  backgroundColor: `${theme.colors.white}`,
}));

export type TextAreaProps = {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>, value: string) => void;
  errorMessage?: string;
  placeholder?: string;
  minHeight?: string;
  textAreaProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;
} & Omit<React.ComponentProps<typeof Box>, 'onChange'>;

export const TextArea = ({
  value,
  onChange,
  errorMessage = '',
  placeholder,
  minHeight,
  textAreaProps,
  ...rest
}: TextAreaProps) => {
  const ref = useRef<HTMLTextAreaElement & HTMLInputElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    ref.current.style.height = '0';
    ref.current.style.height = ref.current.scrollHeight + 'px';
  }, [value, ref]);

  return (
    <Box position='relative' alignItems='center' width='100%' {...rest}>
      <TextAreaStyled
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange && onChange(e, e.target.value)}
        minHeight={minHeight}
        {...textAreaProps}
      />
      {errorMessage && (
        <Box className='error' position='absolute' mt={2} color='red'>
          {errorMessage}
        </Box>
      )}
    </Box>
  );
};
